import { ArrowLeftCircle, UserCog } from "lucide-react";

import { ApiError } from "@/api/client";
import { useCurrentUser, useStopImpersonating } from "@/api/hooks";

/** Persistent top banner shown whenever the active session is an
 *  impersonation. Renders nothing for normal sessions.
 *
 *  The "Stop" button POSTs /auth/stop-impersonating which swaps the
 *  cookie back to the original admin's session + refetches. */
export function ImpersonationBanner() {
  const me = useCurrentUser();
  const stop = useStopImpersonating();
  const impersonator = me.data?.impersonated_by ?? null;

  if (!impersonator) return null;

  return (
    <div className="border-b border-graphite bg-pencil-yellow text-graphite">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-6 py-2">
        <div className="flex items-center gap-2 text-sm">
          <UserCog className="h-4 w-4 flex-none" aria-hidden />
          <span>
            <strong className="font-mono">{impersonator.display_name}</strong> is signed in as{" "}
            <strong className="font-mono">{me.data?.display_name}</strong>{" "}
            <span className="font-mono text-xs text-graphite-soft">({me.data?.email})</span>
          </span>
        </div>
        <button
          type="button"
          onClick={() => stop.mutate()}
          disabled={stop.isPending}
          className="inline-flex items-center gap-1.5 rounded border border-graphite bg-paper px-3 py-1 font-mono text-xs font-semibold text-graphite transition hover:bg-paper-warm disabled:opacity-50"
        >
          <ArrowLeftCircle className="h-3.5 w-3.5" aria-hidden />
          {stop.isPending ? "Stopping…" : "Stop impersonating"}
        </button>
      </div>
      {stop.error && (
        <div className="mx-auto max-w-7xl px-6 pb-2 text-xs text-red-pencil">
          {stop.error instanceof ApiError ? stop.error.detail : "Could not stop impersonating."}
        </div>
      )}
    </div>
  );
}
